import { useParams, Navigate } from 'react-router-dom'
import { useProfile, dayNumberFromStartDate } from '../lib/hooks'
import DayDetail from './DayDetail'
import { TOTAL_DAYS } from '../data/plan'

export default function DayRoute() {
  const { dayNumber } = useParams()
  const { profile } = useProfile()
  const n = parseInt(dayNumber, 10)

  if (!Number.isFinite(n) || n < 1 || n > TOTAL_DAYS) return <Navigate to="/today" replace />

  const currentDay = profile?.startDate ? dayNumberFromStartDate(profile.startDate) : null
  return <DayDetail dayNumber={n} isToday={n === currentDay} />
}
